import React, {Component, ReactNode} from "react"
import {get} from "lodash"
import {CodeContext} from "@irati/deals/context"

import {Deal, DealRedemption} from "@irati/types"
import {COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS} from "@irati/deals/constants/dealType"

import TicketRepeater from "./TicketRepeater"
import SuccessImage from "./SuccessImage"
import Terms from "./Terms"
import BirthdayBoxTicket from "./Ticket/BirthdayBoxTicket"
import TicketTop from "./TicketTop"
import TicketBottom from "./TicketBottom"
import TicketInstructions from "./TicketInstructions"
import DownloadPdf from "./DownloadPdf"
import ContactInfo from "../Deal/ContactInfo"

import "./styles/Tickets.css"

interface Props {
  children?: ReactNode,
  deal: Deal,
  vouchers: any[],
  redemption: DealRedemption
}

class Tickets extends Component<Props> {
  static defaultProps: Partial<Props> = {
    children: null
  }

  showBirthdayBoxTicket = () => {
    return !!this.props.deal?.isBirthdayBox
  }

  render() {
    const pdf = get(this.props.redemption, "pdf")
    const {deal, redemption, vouchers, children} = this.props

    return (
      <div className="tickets">
        <TicketTop>
          <SuccessImage vouchers={vouchers} />
          <TicketInstructions
            item={deal}
            instructions={get(redemption, "dealSnapshot.redemptionInstructions")} />
          <DownloadPdf pdf={pdf} className="center" />
        </TicketTop>
        {this.showBirthdayBoxTicket() && (
          <BirthdayBoxTicket vouchers={vouchers} />
        )}
        {!this.showBirthdayBoxTicket() && (
          <CodeContext.Provider value={{shouldAutoOpenLink: true}}>
            <TicketRepeater redemptionId={redemption.uuid} vouchers={vouchers} externalLinks={deal?.externalLinks} />
          </CodeContext.Provider>
        )}
        <TicketBottom>
          {children}
          <Terms />
          {get(deal, "type") === DEAL_TYPE_COMPANY_BENEFITS &&
            <ContactInfo showHr={false} deal={deal} />
          }
        </TicketBottom>
      </div>
    )
  }
}


export default Tickets
